import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpEventType
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from '../auth/auth.service';
import { TokenService } from './token.service';
import { AlertServiceService } from './alert-service.service';

@Injectable()
export class InterceptorInterceptor implements HttpInterceptor {
  private pendingRequests: number = 0;
  constructor(
    public router: Router,
    private spinner: NgxSpinnerService,
    public tokenService: TokenService,
    // private as: AlertServiceService,
    // private auth: AuthService
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
   
     // ✅ IF FILE DOWNLOAD → DO NOTHING SPECIAL
 const headersConfig: any = {
    // Accept:'application/json'
  };

    // Show spinner
    this.pendingRequests++;
    if (this.pendingRequests === 1) {
      // this.spinner.show();
      this.spinner.show(undefined, {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    }

    // Token setup
    const token = this.tokenService.getToken();
    if (token && !this.tokenService.isTokenExpired()) {
      const ip = (window as any).myip || '0.0.0.0';
      headersConfig['Authorization'] = `Bearer ${token}`;
      headersConfig['routePath'] = window.location.href;
      headersConfig['partnerid'] = this.tokenService.getUser().customerId.split('-')[1] || '100000';
      headersConfig['Access-Control-Allow-Headers'] = 'Content-Type';
      headersConfig['type'] = 'QTVendor';
      headersConfig['ip'] = ip;
      req = req.clone({ setHeaders: headersConfig });
    }
 if (req.responseType === 'blob') {
  return next.handle(req); // do nothing
}
    return next.handle(req).pipe(
      tap({
        next: (event: HttpEvent<any>) => {
          // 🔥 CHECK RESPONSE HERE
          if (event.type === HttpEventType.Response) {
            // console.log('API Response:', event.body); 
            if (!event.body.success && event.body.message === "Unauthorized") {
              this.spinner.hide();
              this.router.navigate([`/login`]);
            }
          }
        },
        error: (err: HttpErrorResponse) => {
          this.spinner.hide();
          if (err.status === 401) {
            this.router.navigate([`/login`]);
          } else if (err.status === 500) {
            this.router.navigate([`/err/${err.status}/${err.message}`]);
          } else if (err.status === 503) {
            const msg = err.error.message.replaceAll(' ', '_');
            this.router.navigate([`/err/${err.status}/${msg}`]);
          } else if (err.status === 0) {
            this.router.navigate(['/err/0/Under_Maintenance']);
          }
        }
      }),
      finalize(() => {
        this.pendingRequests--;
        if (this.pendingRequests === 0) {
          this.spinner.hide();
        }
      })
    );
  }

}
